"use strict";

import {
  Box,
  Container,
  Card,
  CardMedia,
  CardContent,
  Divider,
  Collapse,
  Alert,
  IconButton,
  LinearProgress,
  Grid,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { GoogleLogin } from "@react-oauth/google";
import { useSignIn } from "../hooks/useSignIn";

/* principal component */
function SignIn() {
  const {
    loading,
    loadingGoogle,
    setAlert,
    alertContent,
    handleGoogle,
    showGoogle,
    setLoadingGoogle,
    setAlertContent,
    alert,
  } = useSignIn();

  return (
    <Container component="main">
      <Box sx={{ mt: 1 }} component="form">
        <Grid
          style={{
            minHeight: "100vh",
          }}
          justifyContent="center"
          alignItems="center"
          direction="column"
          container
        >
          <Grid item>
            {/* */}
            <Card
              sx={{
                width: 345,
              }}
            >
              {(loading || loadingGoogle) && (
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 345,
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <LinearProgress />
                </Box>
              )}

              <CardMedia
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <img
                  alt="Inter MX"
                  src="data:image/png;base64,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"
                ></img>
              </CardMedia>

              <Divider />

              <CardContent>
                {/* alert */}
                <Collapse in={alert}>
                  <Alert
                    action={
                      <IconButton
                        onClick={() => setAlert(false)}
                        aria-label="close"
                        color="inherit"
                        size="small"
                      >
                        <Close fontSize="inherit" />
                      </IconButton>
                    }
                    severity="error"
                    variant="filled"
                  >
                    {alertContent}
                  </Alert>
                </Collapse>

                {/* google */}
                <Grid
                  rowSpacing={2}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  container
                >
                  <Grid xs={12} sm={6} md={4} item>
                    <Typography
                      sx={{ flexGrow: 1 }}
                      variant="h6"
                      component="h1"
                      noWrap
                    >
                      Welcome
                    </Typography>
                  </Grid>

                  {showGoogle && (
                    <Grid xs={12} sm={6} md={4} item>
                      <div id="parent">
                        <GoogleLogin
                          click_listener={() => setLoadingGoogle(true)}
                          onSuccess={(response) => handleGoogle(response)}
                          onError={() => {
                            setAlertContent("Error with the Google Signin");
                            setAlert(true);
                          }}
                          prompt_parent_id="parent"
                          size="large"
                          width="100px"
                          theme="outline"
                        />
                      </div>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default SignIn;
